// FILE: src/pages/Terms/Terms.jsx
import React from "react";

export default function Terms() {
  return (
    <main className="section">
      <div className="container">
        <h1 className="fw-bold text-ink mb-3">Terms of Service</h1>
        <p className="text-muted-2">
          These Terms govern your use of TekiMart websites and services. By accessing our site,
          you agree to these Terms. We may update them from time to time. Continued use means you accept the changes.
        </p>
        <h5 className="mt-4 text-ink">Use of Services</h5>
        <p className="text-muted-2">
          You agree not to misuse our services or interfere with their normal operation.
        </p>
        <h5 className="mt-4 text-ink">Intellectual Property</h5>
        <p className="text-muted-2">
          All trademarks, logos, and content are the property of TekiMart or our clients and are
          protected by applicable laws.
        </p>
        <h5 className="mt-4 text-ink">Limitation of Liability</h5>
        <p className="text-muted-2">
          TekiMart is not liable for indirect or consequential damages arising from the use of
          our site or services to the maximum extent permitted by law.
        </p>
      </div>
    </main>
  );
}
